import React from "react";
import Slider from "react-slick";
import '../styles/components/sliders.scss';

function Slider1(props) {
    const images = props.data.images;
    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000      
    }; 
    return (
        <div className="laptop-slider">
            <Slider className="laptop" {...settings}>
                {images.map((d,i) =>
                    <div key={i}><img src={d.laptop} alt={d.alt} /></div>
                )}                                           
            </Slider>
        </div>
    );
}

export default Slider1;